<div class="loadingOverlay" [hidden]="!isLoading" >

	<div style="position: absolute;
	/* padding-top: 25%; */
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);">
	  <p class="loadingText">{{ loadingtext }}</p>

	  <mat-spinner style="margin: auto; color:white !important;"></mat-spinner>
	</div>

  </div>

<div id = "header" style="padding:1%;">
	<div class="titleBox">
		<h1 style="text-align: left;color:#424242"> Manager Dashboard</h1>
	</div>
	<div style="display:flex;">

		<div style="padding-top: 5px;">
			<p style="font-size: 24px;
			color: #858585;">{{customerName}}</p>
		</div>

		<div class="titleBox" style="padding-left: 2%;" *ngIf="isAdmin" [formGroup]="bf">
			<input class="custom-placeholder" #custname style="width: 280px;
			height: 50px;
			font-size: 20px;
			font-weight: bold;
			border: none;
			border-radius: 5px;
			outline: none;" formControlName="filter" placeholder="Which customer?" [matAutocomplete] = "custauto">
		</div>

	</div>
</div>

<div class = "row">
    <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectCustomer($event.option.value)">
      <mat-option *ngFor="let customer of (customer$ | async)" [value]="customer">
        <span>{{ customer.customer_name }}</span>
      </mat-option>
    </mat-autocomplete>
</div>

<div style="width:100%;">
  <div style="padding:1%;">
	<div class="input-icon-container" style="text-align: left; margin-top:48px;">
			<input class="input-custom-style" [(ngModel)] ='searchtext'>
			<fa-icon class = "input-icon" [icon]="fasearch"></fa-icon>
	</div>
  </div>

  <!--
	<div style="width: 30%; padding:1%;">
			 <mat-expansion-panel (opened)="panelOpenState = true"
                       (closed)="panelOpenState = false">
	    <mat-expansion-panel-header>
	      <mat-panel-title style="color: #b2afaf !important;">
	        Filter Options
	      </mat-panel-title>
	    </mat-expansion-panel-header>
				<mat-checkbox (change)="updateToggle($event)">Show Homes Needing Re-Inspection</mat-checkbox>
				<mat-checkbox (change)="updateNeedReviewToggle($event)">Show Energy Star Checklists needing Review</mat-checkbox>
	  </mat-expansion-panel>
	</div>
-->

<!--color: primary; color: accent; 
		[disabled]="escertsfiltered && chip !== 'ES Certificate'" 
-->

<div style="padding: 1%; margin-top: 20px; ">
	<p style="font-size: 20px;
    letter-spacing: -0.4px;
    font-weight: bold;">Filter: <span (click)="resetFilter()"  class="ResetText" *ngIf="selectedChips.length > 0">Reset</span></p>
	<mat-chip-list aria-label="Filter Selection">
		<mat-chip 
		*ngFor="let chip of chips"
		class="filterButtonClass"
		[class.filterButtonSelected]="isSelected(chip)"
		(click)="toggleSelection(chip)">
		{{ chip }}
		</mat-chip>
	</mat-chip-list>
</div>

<!--
<div *ngIf="escertsfiltered">
	<p style="padding: 1%;
    font-size: 16px;
    color: #a9a9a9;
    line-height: 1px;
    font-weight: bold;
    letter-spacing: -0.4px;" *ngIf="escertsfiltered">*Other filters cannot be used while "ES Certificates" is selected. </p>
</div>
-->


	<div *ngIf="!noHomesFound" id="main-table" style="padding-right: 8%; padding:1%; width: max-content;margin: 0 auto; white-space: noWrap;">

		<table class="celiatable" style="width:80vw; margin-top:24px;">
				<tr style="width: 100%;border-width: 0 0 1px;border-style: solid;border-color: #424242;" >
					<th style="width:12%; padding:0 8px;">Address</th>
					<th style="width:12%; padding:0 8px; ">Status</th>
					<th *ngIf="!eiformFiltered" style="width:16%; padding:0 8px; ">Last Inspection</th>
					<th style="width:8%; padding:0 8px; ">Manager</th>
					<th style="width:8%; padding:0 8px;">HVAC</th>
					<!-- <th style="width:10%; padding:0 8px;">Reports/ Certificates</th> -->
				</tr>
				<tr  style="padding-bottom: 20px; height: 120px;" *ngFor="let house of homes | filter: searchtext; let indexOfElement = index;">

					<td style="padding: 10px 10px 10px 0px;">
						<div><p sytle="font-size: 18px;color: #424242;font-weight:bold">{{house.street_address}}</p></div>
						<div><p style="color: #7f7f7f;
							white-space: break-spaces;">{{house.fullsublot}}</p></div>
					</td>
					<td *ngIf="!eiformFiltered">

						
												<div>

													<button color='lightgrey' *ngIf="(house.builder_done || house.builder_done == null) && house.pdwdone && house.cert_printed == false && house.builder_initials != null" style="border:none;">
														  <span style="font-weight: 400;color: #424242;">Awaiting Final</span>
													 </button>

													<button mat-button color="warn" class="shadowwarn"  *ngIf="(house.builder_done || house.builder_done == null) && house.pdwdone && house.cert_printed == false && house.builder_initials == null" (click)="mustCorrectOpen(house.location_id, indexOfElement, house.originalIndex)">
														 Review/Sign Checklist
													 </button>
						
													<button mat-button color="warn" class="shadowwarn"  *ngIf="!house.builder_done && house.pdwdone && house.builder_done != null && house.cert_printed == false && house.builder_initials == null" (click)="mustCorrectOpen(house.location_id, indexOfElement, house.originalIndex)">
														Review/Sign Checklist
													 </button>
						
													 <button mat-button color='lightgrey' class="shadownorm" *ngIf="!house.pdwdone && !house.builder_done" style="border:none;">
														  <span style="font-weight: 400;color: #424242;">Predrywall not completed</span>
													 </button>

													 <button mat-button class="esCert" *ngIf="house.builder_done && house.cert_printed == true && !excludedIDs.includes(customerid)" (click)="getESReport(house.subdivision_name, house.fullsublot, house)">
														 View ES Certificate
													 </button>
						
												</div>
						</td>
					<td style="padding-top: 1%;" id="lastInspection">
						<div>
							<div><p style="font-size: 18px;color: #424242;">{{house.customer_jobtype}} - {{house.job_status}}</p></div>
							<div><button style="font-size: 16px;
								font-weight: 600;
								padding-left: 0;" *ngIf="house.customer_jobtype.includes('Performance') || house.customer_jobtype.toLowerCase().includes('rescheck')" class="performanceReportButton" (click)="getPerfReport(house)">View Report--><i class="fa-solid fa-file-invoice"></i></button>
							</div>
							<div *ngIf="(house.customer_jobtype?.trim() != house.perf_report_type?.trim() ) && (house.perf_report_type) ">
								<button class="performanceReportButton" style="font-size: 16px;
								font-weight: 600;background: none;
								border: none;" (click)="getPerfReport(house)">View Report--><i class="fa-solid fa-file-invoice"></i>></button>
							</div>
							<div><p style="color: #7f7f7f;">{{house.schedule_date|date:'MM-dd-yy'}}</p></div>
							<fa-icon [hidden]="showExclamation(house)" style="color: red;" [icon]="fec"></fa-icon>
						</div>

					</td>
					

					<td *ngIf="!perfreportFiltered"><p style="white-space: break-spaces;">{{house.name}}</p></td>
					<td><p>{{house.hvaccontractor}}</p></td>
					<!--
					<td>
						<p class="reportText" *ngIf="house.cert_printed" (click)="getESReport(house.fullsublot)">View ES Certificate</p>
						<p class="reportText" *ngIf="house.cert_printed" (click)="getPerfReport(house)">View Performance Report</p>
					</td>
					-->
				</tr>
		</table>


	</div>


	<div *ngIf="noHomesFound">
		<div style="padding:1%;">
			<p style="font-size: 24px;
			color: #858585;">No homes available!</p>
		</div>
	</div>


</div>
